import { MessageCircle } from "lucide-react";
import { whatsappLink } from "../../utils/constants";

export const WhatsAppButton = () => {
  return (
    <a
      href={whatsappLink("default")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-btn"
      className="fixed bottom-5 right-5 z-40 md:hidden flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/30 transition-transform hover:scale-105 active:scale-95"
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle size={26} fill="white" strokeWidth={0} />
    </a>
  );
};
